import { ReactElement } from 'react'

import FindByNomeImpl from 'shared/modules/cidades/domain/usecases/FindByNome'
import CidadeRepository from 'shared/modules/cidades/infra/respositories/CidadeRepository'

import FiltrosLotesSolicitados from '../../pages/Filtros'

const Filtros = (): ReactElement => {
  const cidadeRepository = new CidadeRepository()
  const findByNomeImpl = new FindByNomeImpl(cidadeRepository)

  return <FiltrosLotesSolicitados findByNome={findByNomeImpl} />
}

export default Filtros
